import { config } from '@abyss/web/tools/config';
import { storage } from '@abyss/web/tools/storage';
import dynamic from 'next/dynamic';

// This provider wraps the GuestExperience component (defined in GuestExperience.tsx) to provide LaunchDarkly context
export const LDProvider = dynamic(
  async () => {
    const { asyncWithLDProvider } = await import(
      'launchdarkly-react-client-sdk'
    );

    // Parse cookie if needed to get guest id
    const guestUser = `guest-${storage.cookie.get('PSX_GUEST_SESSION')}`;

    return asyncWithLDProvider({
      clientSideID: config('LD_CLIENT_ID_PSX') || '65a48dce975b3a1017c7be9d',
      context: {
        key: guestUser || 'guest-test-user',
        kind: 'user',
        name: guestUser || 'guest-test-user',
      },
    });
  },
  { ssr: false }
);
